import { useState } from "react";

import { EmvGlobalConfigurationEditForm } from "src/app/features/EmvGlobalConfiguration/components/forms/EmvGlobalConfigurationEditForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { RefreshButton } from "../../../../components/FeatureButtons/RefreshButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";

export const EmvGlobalConfigurationEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const hasWriteAccess = canAccess(ResourceName.EMV_GLOBAL_CONFIGURATIONS, "canWrite");
    const hasAccess = canAccess(ResourceName.EMV_GLOBAL_CONFIGURATIONS, "canRead");

    return (
        <FPage>
            {hasAccess ? (
                <>
                    <FPageHeader>
                        <PageTitle translationKey="page.title.emvGlobalConfigurationsEditFormPage" />
                        {hasWriteAccess && (
                            <ActionBar>
                                <SubmitButton isDisabled={false} onClick={triggerFormSubmit} />
                                <RefreshButton isDisabled={false} />
                            </ActionBar>
                        )}
                    </FPageHeader>
                    <FPageContent>
                        <EmvGlobalConfigurationEditForm runSubmit={runSubmit} />
                    </FPageContent>
                </>
            ) : (
                <NoAccessLayout />
            )}
        </FPage>
    );
};
